<span class="score " [class.score-low]="infringementScore?score>6:score<=3" [class.score-mid]="score>3&&score<=6" [class.score-high]="infringementScore?score<=3:score>6">
    {{score}}
</span>